import React, {Component} from 'react';

class BannerAppAd extends Component {
  state = {
    popupType: true,
    showPopup: true,
    covid: false,
  };

  closePopup = () => {
    // this.setState({ showPopup: showPopup ? false : true });
    // console.log('fun');
  };

  async componentDidMount() {
    const show = await this.getData();
    if (show) {
      this.setState({
        covid: true,
      });
    }
  }

  getData = async () => {
    try {
      const route = '/local/php_interface/api/v2/cinema/covid/';
      const response = await fetch(route);
      const result = await response.json();

      return result.status === 'success' && result.data === true;
    } catch (error) {
      return false;
    }
  };

  covid = (title, text) => {
    return (
        <div className={`banner-mobileapp banner-mobileapp--covid banner-mobileapp--${this.props.type}`}>
          <div className="banner-mobileapp__text">
            <h3 className="banner-mobileapp__title">{title}</h3>
            <p className="banner-mobileapp__description" dangerouslySetInnerHTML={{__html: text}}></p>
            <div className="banner-mobileapp__actions">
            </div>
          </div>
          <div className="banner-mobileapp__image"></div>
          <button className="banner-mobileapp__close"></button>
        </div>
    );
  };

  default = (title, text) => {
    // Поддерживаем red, blue, telegram - все используют новый дизайн
    const bannerType = ['red', 'blue', 'telegram'].includes(this.props.type)
      ? this.props.type
      : 'red';
    return (
        <div className={`banner-mobileapp banner-mobileapp--${bannerType}`}>
          <div className="banner-mobileapp__text">
            <h3 className="banner-mobileapp__title">{title}</h3>
            <p className="banner-mobileapp__description" dangerouslySetInnerHTML={{__html: text}}></p>
            <div className="banner-mobileapp__actions">
              <a
                href="https://t.me/comfortkino"
                target="_blank"
                rel="noreferrer"
                className="banner-mobileapp__actions__telegram"
              ></a>
              <a
                href="https://max.ru/comfortkino"
                target="_blank"
                rel="noreferrer"
                className="banner-mobileapp__actions__max"
              ></a>
            </div>
          </div>
          <div className="banner-mobileapp__image"></div>
          <button className="banner-mobileapp__close"></button>
        </div>
    );
  };

  render() {
    const {
      covid,
    } = this.state

    let title, text;
    if (covid) {
      title = 'Внимание! Ограничения связанные с вакцинацией от COVID-19';
      text = 'Гостям до 18 лет услуги оказываются без ограничений, при наличии документа подтверждающего возраст.<br><br>' +
        'Старше 18 услуги оказываются строго при наличии:<br>' +
        '1. документа удостоверяющего личность (паспорт, права и т.д.)<br><br>' +
        '2. одного из следующих документов (в бумажном или электронном виде):<br>' +
        '- справка или сертификат о вакцинации против COVID-19<br>' +
        '- справка о противопоказаниях к вакцинации<br>' +
        '- справка об отрицательном анализе на COVID-19 (ПЦР), сроком выдачи не старше 3 суток<br>';
    } else {
      title = 'Го в телегу! Или в MAX.';
      text = 'Быть подписанными на наши каналы полезно. Дарим промокоды, разыгрываем билеты в кино, публикуем эксклюзив. Выбирай свой мессенджер и свою атмосферу. Мы рядом и у нас интересно.';
    }

    if (covid) {
      return this.covid(title, text);
    } else {
      return this.default(title, text);
    }
  }
}

export default BannerAppAd;
